import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useCart, useCoreContext } from 'lib/core/hooks'
import { getCheckoutConfig } from 'lib/core/data/quote/checkoutConfig/selectors'
import { getPlaceOrder } from 'lib/core/data/quote/placeOrderNext/selectors'
import { getPlaceOrder as getPlaceOrderRest } from 'lib/core/data/quote/placeOrder/selectors'
import { getIsFetching as getCountryInfoIsFetching } from 'lib/core/data/common/countryInfo/selectors'
import { fetchCountryInfo } from 'lib/core/data/common/countryInfo'
import { getIsCheckoutLocked } from 'lib/core/data/quote/lockCheckout/selectors'
import { fetchCheckoutConfig } from 'lib/core/data/quote/checkoutConfig'

export const useCheckoutInit = () => {
  const dispatch = useDispatch()
  const { checkoutCountries } = useCoreContext()
  const countryInfoIsFetching = useSelector(getCountryInfoIsFetching(checkoutCountries))
  const { cartId, cart } = useCart()
  const checkoutConfig = useSelector(getCheckoutConfig(cartId))
  const { isFetching: isPlacingOrder } = useSelector(getPlaceOrder(cartId))
  const { isFetching: isPlacingOrderRest } = useSelector(getPlaceOrderRest(cartId))
  const isCheckoutLocked = useSelector(getIsCheckoutLocked(cartId))
  const { isSuccess, isFailure, isFirstLoad, count } = cart ?? {}
  const isCartEmpty = isSuccess && !count
  const isFetchingConfig = (!checkoutConfig || checkoutConfig.isFetching)
  const isLocked = isCheckoutLocked || isPlacingOrder || isPlacingOrderRest

  useEffect(() => {
    checkoutCountries.forEach(code => dispatch(fetchCountryInfo(code)))
    // eslint-disable-next-line
  }, [dispatch])

  useEffect(() => {
    if (cartId) {
      dispatch(fetchCheckoutConfig(cartId))
    }
  }, [dispatch, cartId])

  return {
    isCartEmpty,
    isFailure,
    isLoading: Boolean(isFirstLoad) || countryInfoIsFetching || isFetchingConfig,
    isLocked
  }
}
